var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogleCloudStorageIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aecbfa;}.cls-2{fill:#669df6;}.cls-3{fill:#4285f4;}.cls-4{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_24px_CloudStorage_Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 4,
    width: 20,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 20,
    y: 4,
    width: 2,
    height: 7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "22 4 20 4 20 11 22 4"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2,
    y: 4,
    width: 2,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 6,
    y: 7,
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 15,
    y: 6,
    width: 3,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 13,
    width: 20,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 20,
    y: 13,
    width: 2,
    height: 7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "22 13 20 13 20 20 22 13"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2,
    y: 13,
    width: 2,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 6,
    y: 16,
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 15,
    y: 15,
    width: 3,
    height: 3,
    rx: 1.5
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleCloudStorageIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google-cloud-storage-icon.b9679997c1633a26582f8422a36fcd7f.svg";